const Config = {
  AUTOSTART: false,
  DEBUG: false
};

export { Config };